import { render, staticRenderFns } from "./PartsControlReturnParts.vue?vue&type=template&id=3afdc490&scoped=true"
import script from "./PartsControlReturnParts.vue?vue&type=script&lang=js"
export * from "./PartsControlReturnParts.vue?vue&type=script&lang=js"
import style0 from "./PartsControlReturnParts.vue?vue&type=style&index=0&id=3afdc490&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afdc490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afdc490')) {
      api.createRecord('3afdc490', component.options)
    } else {
      api.reload('3afdc490', component.options)
    }
    module.hot.accept("./PartsControlReturnParts.vue?vue&type=template&id=3afdc490&scoped=true", function () {
      api.rerender('3afdc490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/partsControl/orderControlScreens/returnParts/PartsControlReturnParts.vue"
export default component.exports